import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import CardMenu from "../cardMenu";
import ThemeList from "./themeList";


const CardTheme = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Business Update</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <CardMenu />
                <div className="content-right">
                    <ThemeList />
                </div>
            </div>
        </div>
        
    );
}

export default CardTheme;
